import { lighten } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 2.38rem 2.38rem;

  @media (max-width: 1024px) {
    padding: 0 1.38rem;
  }
`;

export const MainContent = styled.div`
  width: calc(100% - var(--videobar-width));
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2rem 0 0;
`;

export const TitleWrapper = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  > svg {
    margin-right: 0.88rem;
  }

  h1 {
    font-family: 'RedHatDisplay-Extrabold';
    color: #1e88e5;
    font-size: 2rem;
    line-height: 2.55rem;
  }

  > div > svg {
    display: block;
    margin: auto;
    position: relative;
    cursor: pointer;
    transition: stroke 0.3s;
  }

  > div > svg {
    stroke: ${lighten(0.16, '#63646A')};

    &:hover {
      stroke: #63646a;
    }
  }

  p {
    font-family: 'MarkPro';
    font-size: 1rem;
    line-height: 1.44rem;
    margin-left: 1.88rem;
  }
`;

export const Title = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.5rem;

  > h1 {
    font-family: 'RedHatDisplay-Extrabold';
    color: #1e88e5;
    margin-left: 0.88rem;
    font-size: 1.5rem;
    line-height: 2.55rem;
  }
`;

export const WrapperMainContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const NavigationMenu = styled.div`
  padding-top: 3vh;

  @media (max-width: 1024px) {
    padding-top: 1vh;
  }

  .profile-navBar {
    width: 98%;
    background: none;
    border: 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
    box-shadow: none;
    margin-bottom: 4.11vh;

    @media (max-width: 1024px) {
      margin-bottom: 3.11vh;
    }
  }

  .profile-tabs-container {
    overflow: visible !important;
  }

  .MuiTabs-scroller.MuiTabs-fixed {
    overflow: visible !important;
  }

  .profile-tab-item {
    margin-right: 3.22rem;
    > span {
      font-family: 'RedHatDisplay-Regular';
      font-size: 1.22rem;
      color: #000 !important;
      text-transform: none;
    }
  }
`;
